import React, {useState, useEffect} from 'react';
import { Link, useLocation} from 'react-router-dom'
import scrollToTop from './scrollToTop'

export default function Topbar(props) {
    const [navOpen, setNavOpen] = useState(false);
    let location = useLocation();
    let newPath = location.pathname.replace('/cp/', '');
    const [oldPath, setOldPath] = useState(newPath);

    let width = window.innerWidth;
    
    let toggleNav = () => {
        setNavOpen(!navOpen);
    }

    useEffect(() => {
        setNavOpen(false);
    }, [newPath])

    let styleCurrentLink = () => {
        let styleComponent = (id, styles) => {
            document.getElementById(id).style.backgroundColor = styles[0];
            let children = document.getElementById(id).childNodes;
            for(let i = 0; i < children.length; i++) {
                children[i].style.color = styles[1];
                children[i].style.fontWeight = styles[2];
            }
        }
        
        if(oldPath && document.getElementById(oldPath)) {
            styleComponent(oldPath, ['', '', '']);
        }
        if(document.getElementById(newPath)) {
            styleComponent(newPath, ['#232429', '#fff', '900']);
            setOldPath(newPath);
        }
    } 

    useEffect(() => {
        styleCurrentLink();
    }, [oldPath, props.colors, newPath])
    
    scrollToTop();
    return (
        <header className="navbar" style={{backgroundColor: props.colors.background}}>
            <div className="header-container">
                <a href={props.navData.churchWebsite} className="brand-logo">
                    <div className="center logo-container">
                        <img src={props.navData.logo} alt=""/>
                    </div>
                </a>

                { width > 700 ?
                    <div className="links">
                        <Link to={'/cp/give-online'}>
                            <button className="give-online link" id={'give-online'}>
                                <h4><i className="las la-hand-holding-heart"></i> Give</h4>
                            </button>
                        </Link>

                        {props.allowCheckIn ? <Link to={'/cp/checkin'}>
                            <button className="give-online link" id={'checkin'}>
                                <h4> <i className="las la-user-check"></i> Check In</h4>
                            </button>
                        </Link> :  null}

                        {props.allowRsvp ? <Link to={'/cp/rsvp'}>
                            <button className="give-online link" id={'rsvp'}>
                                <h4><i className="las la-bookmark"></i> {props.rsvpLabel.split('-').join(' ')}</h4>
                            </button>
                        </Link> : null}

                        <Link to={'/cp/signin'}>
                            <button className="signin link" id="signin">
                                <h4><i className="las la-user"></i> Sign In</h4>
                            </button>
                        </Link>

                        <Link to={'/cp/signup'}>
                            <button className="signUp link" id={'signup'}>
                                <h4><i className="las la-clipboard-check"></i> Sign Up</h4>
                            </button>
                        </Link>

                        {/* <span className="more-options">
                            <button className="more" onClick={toggleSetMoreOptions}>
                                <span className="waves-effect"><i className="las la-ellipsis-v"></i> more </span>
                            </button>

                            {moreOptionsOpen ? <div className="options">
                                <Link to={'/generate?type=checkin'}>
                                    <button onClick={closeMoreOptions}><h4>Check in</h4></button>
                                </Link>
                                <Link to={'/generate?type=rsvp'}>
                                    <button onClick={closeMoreOptions}><h4>RSVP</h4></button>
                                </Link>
                            </div> : null}
                        </span> */}
                    </div> :

                    <button className={"hamburger " + (navOpen ? "opened" : "")} onClick={toggleNav}>
                        <div className="patty"></div>
                        <div className="patty"></div>
                        <div className="patty"></div>                               
                    </button>
                }

                <div className={"sidebar-container " + (navOpen ? "sidebar-container-show" : "")}>
                    <div className={"sidebar " + (navOpen ? "" : "sidebar-hide")}>
                        <div className="links">
                            <Link to={'/cp/give-online'}>
                                <button className="give-online" id={'give-online'}>
                                    <span>
                                        <i className="las la-hand-holding-heart white-text"></i>
                                    </span>
                                    <h4>Give</h4>
                                </button>
                            </Link>

                            {props.allowCheckIn ? <Link to={'/cp/checkin'}>
                                <button className="give-online link" id={'checkin'}>
                                    <span>
                                        <i className="las la-user-check white-text"></i>
                                    </span>
                                    <h4>Check In</h4>
                                </button>
                            </Link> :  null}

                            {props.allowRsvp ? <Link to={'/cp/rsvp'}>
                                <button className="give-online link" id={'rsvp'}>
                                    <span>
                                        <i className="las la-bookmark white-text"></i>
                                    </span>
                                    <h4>{props.rsvpLabel.split('-').join(' ')}</h4>
                                </button>
                            </Link> :  null}

                            <Link to={'/cp/signin'}>
                                <button className="signin" id={"signin"}>
                                    <span>
                                        <i className="las la-user white-text"></i>
                                    </span>
                                    <h4>Sign In</h4>
                                </button>
                            </Link>

                            <Link to={'/cp/signup'}>
                                <button className="signUp" id={'signup'}>
                                    <span>
                                        <i className="la la-clipboard-check white-text" aria-hidden="true"></i>
                                    </span>
                                    <h4>Sign Up</h4>
                                </button>
                            </Link>
                        </div>

                        <div className="center church-name-nav" style={{backgroundColor: props.colors.secondary}}>
                            <h4 style={{
                                fontWeight: '900',
                                marginLeft: '10px',
                                color: 'white'
                                // fontSize: '13px'
                            }}>{props.navData.orgFullName}</h4>
                            <div className="center dedicated_number">
                                <h4>{props.orgMessagingNumberLabel}</h4>
                                <h4>{props.orgMessagingNumberValue}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="center church-name" style={{backgroundColor: props.colors.secondary}}>
            <h4 style={{
                    fontWeight: '900',
                    marginLeft: '10px',
                    color: 'white'
                    // fontSize: '13px'
                }}>{props.navData.orgFullName}</h4>
                <div className="center dedicated_number">
                    <h4>{props.orgMessagingNumberLabel}</h4>
                    <h4>{props.orgMessagingNumberValue}</h4>
                </div>
            </div>
        </header>
    )
}
